import * as d3 from "d3";

export const variables = {
  population: {
    breaks: [25, 180, 400, 1000, 2000, 4000, 15000],
    mapbox: ["/", ["get", "tot_pop"], ["get", "area"]],
    scale: " people per sq km",
    multiplier: 1,
    display: "Population density",
    color: (v) => d3.interpolateCividis(((v - 0.3) * 1) / 0.8),
    js: (v) => v.tot_pop / v.area,
  },
  asian_pct: {
    breaks: [0, 0.01, 0.03, 0.06, 0.1, 0.2, 0.75],
    scale: "%",
    multiplier: 100,
    mapbox: ["/", ["get", "tot_asian"], ["get", "tot_pop"]],
    color: (v) => d3.interpolateCividis(0.9 - ((v - 0.3) * 1) / 0.8),
    display: "% Asian",
    js: (v) => v.tot_asian / v.tot_pop,
  },
  black_pct: {
    breaks: [0, 0.001, 0.005, 0.02, 0.05, 0.1, 0.2, 0.3],
    scale: "%",
    multiplier: 100,
    mapbox: ["/", ["get", "black"], ["get", "tot_pop"]],
    color: (v) => d3.interpolateCividis(0.9 - ((v - 0.3) * 1) / 0.8),
    display: "% Black",
    js: (v) => v.black / v.tot_pop,
  },
  pct_white: {
    breaks: [0, 0.2, 0.4, 0.65, 0.85, 0.95, 1],
    mapbox: ["/", ["get", "white"], ["get", "tot_pop"]],
    multiplier: 100,
    scale: "%",
    display: "% White",
    color: (v) => d3.interpolateCividis(((v - 0.3) * 1) / 0.8),
    js: (v) => v.white / v.tot_pop,
  },
  income: {
    breaks: [20000, 30000, 35000, 40000, 45000, 55000, 160000],
    mapbox: ["get", "mean_income"],
    multiplier: 1,
    scale: "£",
    display: "Mean household income.",
    color: (v) => d3.interpolateCividis(((v - 0.3) * 1) / 0.8),
    js: (v) => v.mean_income,
  },
  cjrs: {
    breaks: [24, 26, 28, 30, 32, 34, 36],
    mapbox: ["get", "takeup_rate"],
    multiplier: 1,
    scale: "%",
    display: "Coronavirus Job Retention Scheme takeup rate",
    js: (v) => +v.takeup_rate,
    description:
      "Of qualifying employees, the percentage that are furloughed with the Coronavirus Job Retention Scheme.",
  },
  seiss: {
    breaks: [0.45, 0.54, 0.57, 0.6, 0.63, 0.66, 0.74],
    mapbox: ["get", "seiss_takeup"],
    multiplier: 100,
    scale: "%",
    display: "Self-Employment Income Support Scheme takeup rate",
    js: (v) => +v.seiss_takeup,
    description:
      "Of qualifying people (based on tax filings), the percentage that recieved funds through the Self-Employment Income Support Scheme.",
  },
  seiss_value: {
    breaks: [1700, 2300, 2400, 2500, 2600, 2800, 3100],
    mapbox: ["/", ["get", "seiss_clam_value"], ["get", "seiss_claims"]],
    multiplier: 1,
    scale: "£",
    display: "Average SEISS grant",
    js: (v) => +v.seiss_clam_value / +v.seiss_claims,
    description: "Average Self-Employment Income Support Scheme grant value.",
  },
  hosp: {
    breaks: [50, 200, 300, 400, 500, 600, 3000],
    mapbox: ["get", "n_hosp_grant"],
    multiplier: 1,
    scale: "",
    display: "# hospitality grants",
    js: (v) => v.n_hosp_grant,
    filter: ["has", "n_hosp_grant"],
  },
  pct_hosp: {
    breaks: [0, 0.3, 0.35, 0.4, 0.45, 0.5, 1.3],
    mapbox: ["/", ["get", "n_hosp_grant"], ["get", "total_retail_leisure"]],
    multiplier: 100,
    scale: "%",
    display: "% hospitality businesses with hospitality grant",
    js: (v) => v.n_hosp_grant / v.total_retail_leisure,
    filter: ["has", "n_hosp_grant"],
    description:
      "The number of grants awarded through the Retail, Hospitality and Leisure Grant Fund, divded by the number of retail, hospitality, and leisure businesses in a particular parliamentary constituency.",
  },
  local: {
    breaks: [0, 50000, 170000, 330000, 510000, 800000, 3e6],
    mapbox: ["get", "total_local_grant"],
    multiplier: 1,
    scale: "£",
    display: "Local discretionary grant total",
    js: (v) => v.total_local_grant,
    filter: ["has", "n_hosp_grant"],
    description:
      "The total amount granted through the Local Authority Discretionary Fund to businesses in a particular parliamentary constituency.",
  },

  small: {
    breaks: [2.2e6, 7.5e6, 9.5e6, 11e6, 13e6, 16e6, 42e6],
    mapbox: ["get", "total_small_grant"],
    multiplier: 1,
    scale: "£",
    display: "Small business grant total",
    js: (v) => v.total_small_grant,
    filter: ["has", "n_hosp_grant"],
    description:
      "The total amount granted through the Small Business Grants Fund to businesses in a particular parliamentary constituency.",
  },

  total_businesses: {
    breaks: [0, 2500, 3500, 4500, 5500, 6500, 10000],
    mapbox: ["get", "total"],
    scale: "",
    multiplier: 1,
    display: "Total # of businesses",
    js: (v) => v.total,
  },

  pct_hosp_bus: {
    breaks: [0.13, 0.18, 0.2, 0.25, 0.3, 0.35, 0.5],
    mapbox: ["/", ["get", "total_retail_leisure"], ["get", "total"]],
    multiplier: 100,
    scale: "%",
    display: "% of businesses in hospitality sector",
    js: (v) => v.total_retail_leisure / v.total,
    color: (v) => d3.interpolateCividis(((v - 0.3) * 1) / 0.8),
    filter: ["has", "n_hosp_grant"],
    description:
      "The number of hospitality, retail, and leisure businesses divided by the total number of businesses in a particular parliamentary constituency.",
  },

  pct_total: {
    breaks: [1000, 2500, 3500, 5000, 6500, 8000, 30000],
    mapbox: [
      "/",
      [
        "+",
        ["get", "total_small_grant"],
        ["get", "total_hosp_grant"],
        ["get", "total_local_grant"],
      ],
      ["get", "total"],
    ],
    multiplier: 1,
    scale: "£",
    display: "Total grant per business",
    js: (v) =>
      (v.total_small_grant + v.total_local_grant + v.total_hosp_grant) /
      v.total,
    filter: ["has", "n_hosp_grant"],
    description:
      "The total amount granted through all coronavirus grant programs divided by the number of businesses in a particular parliamentary constituency.",
  },

  total_grant: {
    breaks: [3e6, 12e6, 15e6, 20e6, 25e6, 40e6, 90e6],
    mapbox: [
      "+",
      ["get", "total_small_grant"],
      ["get", "total_hosp_grant"],
      ["get", "total_local_grant"],
    ],
    multiplier: 1,
    scale: "£",
    display: "Total grant value",
    js: (v) => v.total_small_grant + v.total_local_grant + v.total_hosp_grant,
    filter: ["has", "n_hosp_grant"],
    description:
      "The total amount granted through all coronavirus grant programs (Small Business Grants Fund; Retail, Hospitality and Leisure Grant Fund; Local Authority Discretionary Fund) to businesses in a particular parliamentary constituency.",
  },

  jobs: {
    breaks: [0.3, 0.6, 0.7, 0.8, 0.9, 1, 14],
    mapbox: ["get", "job_density"],
    multiplier: 100,
    scale: "%",
    display: "Job density",
    js: (v) => v.job_density,
    description: "Available jobs as a percentage of the population."
  },

  pct_self_employed: {
    breaks: [4, 7, 10, 13, 16, 19, 25],
    mapbox: ["get", "selfemployed_pct"],
    multiplier: 1,
    scale: "%",
    display: "% self employed",
    js: (v) => v.selfemployed_pct,
    color: (v) => d3.interpolateCividis(((v - 0.3) * 1) / 0.8),
    description: "Percentage of the total population that was self-employed in 2019-2020.",
    filter: ["has", "selfemployed_pct"],
  },
};

export const interactiveVariables = [
  ["Support schemes", "Local grants", "Demographic data"],
  ["cjrs", "seiss", "seiss_value"],
  ["small", "local", "total_grant", "pct_total", "pct_hosp"],
  [
    "population",
    "jobs",
    "income",
    "pct_white",
    "black_pct",
    "asian_pct",
    "pct_hosp_bus",
    "pct_self_employed",
  ],
];
